<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M22.5 6C22.5 4.9 21.6 4 20.5 4H4.5C3.4 4 2.5 4.9 2.5 6V18C2.5 19.1 3.4 20 4.5 20H20.5C21.6 20 22.5 19.1 22.5 18V6ZM20.5 6L12.5 11L4.5 6H20.5ZM20.5 18H4.5V8L12.5 13L20.5 8V18Z"
      fill="url(#paint0_linear_5364_4510)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5364_4510"
        x1="2.5"
        y1="4"
        x2="18.1864"
        y2="23.4745"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" class="fill-1" />
        <stop offset="1" class="fill-2" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
.fill-1 {
  stop-color: #df252a;
}

.fill-2 {
  stop-color: #a20004;
}
</style>
